import React from 'react'
import GenericActivityDashboard, {
  BORDER_WIDTH,
  hrChartConfiguration,
  lapMinutesFormat, tempChartConfiguration
} from '../generic/GenericActivityDashboard'
import { collectionTypes, timeSeries } from '../../../common/Constants'
import I18n from 'i18n'
import Variables from '../../../../stylesheets/variables.module.scss'
import { seriesRunningMetric, stridemin2stepmin } from '../../../common/Units'
import { smartRounding } from '../../../common/Math'
const { secondaryColor, secondaryColorLight } = Variables

const RunningDashboardSingle = (props) => {
  const summaryFields = [
    'start_date',
    'distance',
    'duration',
    'avg_speed',
    'elevation_gain',
    'elevation_loss',
    'calories',
    'max_core_temperature',
    'tags'
  ]

  const lapFields = [
    { kind: 'fn', name: 'components.dashboards.laps_table.avg_speed', fn: (lap) => lapMinutesFormat(lap, 'summaries.speed.mean') },
    { kind: 'fn', name: 'components.dashboards.laps_table.max_speed', fn: (lap) => lapMinutesFormat(lap, 'summaries.speed.max') },
    { kind: 'path', name: 'components.dashboards.laps_table.avg_hr', path: 'summaries.hr.mean' },
    { kind: 'path', name: 'components.dashboards.laps_table.max_hr', path: 'summaries.hr.max' }
  ]

  const charts = [
    hrChartConfiguration,
    tempChartConfiguration,
    {
      timeSeries: timeSeries.CADENCE,
      config: {
        yTickCallback: v => `${smartRounding(stridemin2stepmin(v), 1)} ${I18n.t('units.steps/min')}`,
        tooltipCallback: { label: (ti) => (`${smartRounding(stridemin2stepmin(ti.parsed.y), 1)} ${I18n.t('units.steps/min')}`) },
        datasetConfig: {
          borderColor: secondaryColor,
          backgroundColor: secondaryColor,
          borderWidth: BORDER_WIDTH,
          fromColor: secondaryColorLight,
          toColor: secondaryColor
        }
      }
    }
  ]

  return (
    <GenericActivityDashboard
      {...props}
      collectionType={collectionTypes.RUNNING}
      speedUnit={seriesRunningMetric.speed}
      summaryFields={summaryFields}
      lapFields={lapFields}
      charts={charts}
    />
  )
}

export default RunningDashboardSingle
